import { configureStore } from '@reduxjs/toolkit';
import videoReducer from './videoSlice';
import authReducer from './authSlice';
import courtReducer from './CourtSlice';
import livestreamReducer from './LivestreamSlice';
import subscriptionReducer from './subscriptionSlice';
import adminUsersReducer from './adminUsersSlice';

// Configure the store
export const reduxStore = configureStore({
  reducer: {
    auth: authReducer,
    video: videoReducer,
    court: courtReducer,
    livestream: livestreamReducer,
    subscription: subscriptionReducer,
    adminUsers: adminUsersReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore actions with these types
        ignoredActions: ['video/download/fulfilled'],
        // Ignore these field paths in actions
        ignoredActionPaths: ['payload'],
        // Ignore these paths in state
        ignoredPaths: ['video.blob'],
      },
    }),
});
